var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #939598;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    ")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("polygon",{"className":"cls-1","points":"20.12 22.98 10.56 17.98 1 22.98 1 1 20.12 1 20.12 22.98"})))]);
}

Bookmark.defaultProps = {"viewBox":"0 0 21.12 23.98"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
